import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/serviceType-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ContractForm';
import { routes } from 'src/navigation';
import Breadcrumbs from 'src/components/Breadcrumbs';
import Router from '../../../../../../navigation/router';
import { RouteComponentProps } from 'react-router-dom';
import Loader from '../../../../../../components/Loader';
import { IStudent } from '../../../../../../types/student';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { IOrder } from '../../../../../../types/order';
import { QueryParams } from '../../../../../../types/grid';

export interface StateProps {
    inProgress: boolean;
    caseNumbersStudent: any;
    student: IStudent | null;
}

export interface DispatchProps {
    getCaseNumbersStudent: (params: any) => void;
    getStudent: (params: any) => void;
}
export interface OwnProps {}

export interface RouteParams {
    id: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps, RouteComponentProps<RouteParams> {}

const ContractCreateScreen: React.FunctionComponent<Props> = (props: Props) => {
    const { caseNumbersStudent, student } = props;
    useEffect(() => {
        props.getCaseNumbersStudent({
            id: props.match.params?.id,
            page: 1,
            itemsPerPage: 1200,
        });
        props.getStudent(props.match.params?.id);
        // eslint-disable-next-line
    }, []);

    if (props.inProgress) {
        return <Loader />;
    }
    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    {
                        name: 'Contracts',
                        path: Router.generate(routes.STUDENT_DETAIL, { id: props.match.params?.id, tab: 'contracts' }),
                    },
                    { name: student?.firstName + ' ' + student?.lastName, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <Form
                    initialValues={{ student: props.match.params?.id }}
                    caseNumbersStudent={props.caseNumbersStudent}
                />
            </div>
        </AdminLayout>
    );
};

export default ContractCreateScreen;
